import classnames from 'classnames';
import {
  canUserEnrollInCash,
  isEnrolledNotFunded,
} from 'helpers/sesameCash.helpers';
import { useFlag } from 'hook/flag.hook';
import BoosterEnhancedCashSummary from 'partial/OfferManager/modules/BoosterEnhancedCashSummary';
import { SESAME_CASH_BOOSTER_ENHANCED_1 } from 'types/sesameCash.constants';
import './SesameCashModule.scss';
import { OverviewCashEnrolled } from './components/OverviewCashEnrolled/OverviewCashEnrolled';

const SesameCashModule = ({
  enrolled,
  hideEnroll,
  handleLearnMore,
  sesameCashEnrolledView,
  isOverviewPage,
  type,
  eventHandler,
  modulePosition,
  handleAccountOptionsClick,
  cashModuleVersion,
  isCashPage,
  isSignupPage,
  overviewRedesignFlag,
  ...props
}) => {
  const cb20GaWebFlag = useFlag('cb2_0_ga_web');

  if (sesameCashEnrolledView) {
    if (
      props.enhanceCashModules &&
      !props.sesameCashAccount.receivedFirstFund
    ) {
      return (
        <BoosterEnhancedCashSummary
          {...props}
          modulePosition={modulePosition ? modulePosition : 1}
          isCashPage={isCashPage}
          cashModuleVersion={cashModuleVersion}
          enhanceCashModules={props.enhanceCashModules}
        />
      );
    } else {
      return (
        <div
          className={classnames('SesameCashEnrolledModule CashLanding ', {
            Overview: isOverviewPage,
          })}
        >
          <OverviewCashEnrolled
            type={'overview'}
            sesameCashmodulePosition={modulePosition}
            handleAccountOptionsClick={handleAccountOptionsClick}
            sesameCashAccount={props.sesameCashAccount}
            eventHandler={eventHandler}
            history={props.history}
            cashModuleVersion={cashModuleVersion}
            creditInfo={props.creditInfo}
            userInfo={props.userInfo}
            builderManager={props.builderManager}
            cb20GaWebFlag={cb20GaWebFlag}
          />
        </div>
      );
    }
  } else {
    if (
      cashModuleVersion === SESAME_CASH_BOOSTER_ENHANCED_1 ||
      (props.enhanceCashModules &&
        !(
          (canUserEnrollInCash(props.userInfo) &&
            !(props.cashModuleVersion === SESAME_CASH_BOOSTER_ENHANCED_1)) ||
          props.isCashPage
        ) &&
        !(
          isEnrolledNotFunded(props.userInfo, props.sesameCashAccount) &&
          props.cashModuleVersion === SESAME_CASH_BOOSTER_ENHANCED_1
        ))
    ) {
      return (
        <BoosterEnhancedCashSummary
          {...props}
          modulePosition={modulePosition ? modulePosition : 1}
          isCashPage={isCashPage}
          isOverview={isOverviewPage}
          cashModuleVersion={cashModuleVersion}
          enhanceCashModules={props.enhanceCashModules}
        />
      );
    } else {
      if (
        !isSignupPage &&
        cashModuleVersion === SESAME_CASH_BOOSTER_ENHANCED_1
      ) {
        return <BoosterEnhancedCashSummary {...props} />;
      } else {
        return <></>;
      }
    }
  }
};

export default SesameCashModule;
